import { render, staticRenderFns } from "./DataListIcon.vue?vue&type=template&id=4d10dae2&"
import script from "./DataListIcon.vue?vue&type=script&lang=js&"
export * from "./DataListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports